import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_OPTIONS } from '@/config/settings/language-config';

export const useLanguageSettings = () => {
  const { i18n } = useTranslation(['settings']);

  const [selectedLanguage, setSelectedLanguage] = useState<string>(() => {
    const short = i18n.language?.slice(0, 2);
    return short || 'fr';
  });

  const handleLanguageChange = (code: string) => {
    setSelectedLanguage(code);
    i18n.changeLanguage(code);
  };

  const languages = LANGUAGE_OPTIONS;

  return {
    selectedLanguage,
    handleLanguageChange,
    languages,
  };
};
